(function () {
  'use strict';

  function initChat(widget) {
    var apiUrl      = widget.dataset.apiUrl;
    var toggleBtn   = widget.querySelector('[data-flowik-chat-toggle]');
    var panel       = widget.querySelector('[data-flowik-chat-panel]');
    var messagesEl  = widget.querySelector('[data-flowik-chat-messages]');
    var quickEl     = widget.querySelector('[data-flowik-chat-quick]');
    var form        = widget.querySelector('[data-flowik-chat-form]');
    var input       = widget.querySelector('[data-flowik-chat-input]');
    var sendBtn     = form.querySelector('[type="submit"]');
    var iconOpen    = widget.querySelector('[data-flowik-chat-icon-open]');
    var iconClose   = widget.querySelector('[data-flowik-chat-icon-close]');

    var history = [];
    var isOpen = false;
    var isSending = false;

    function setOpen(open) {
      isOpen = open;
      panel.classList.toggle('is-hidden', !open);
      iconOpen.classList.toggle('is-hidden', open);
      iconClose.classList.toggle('is-hidden', !open);
      if (open) input.focus();
    }

    toggleBtn.addEventListener('click', function () { setOpen(!isOpen); });

    function addMessage(text, role) {
      var el = document.createElement('div');
      el.className = 'flowik-chat__msg flowik-chat__msg--' + role;
      el.textContent = text;
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function sendMessage(text) {
      text = (text || '').trim();
      if (!text || isSending) return;

      addMessage(text, 'user');
      history.push({ role: 'user', text: text });
      quickEl.classList.add('is-hidden');
      input.value = '';
      isSending = true;
      sendBtn.disabled = true;

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: history.slice(-8) }),
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || result.data.error) {
            addMessage(result.data.error || 'Odpověď se nepodařilo získat. Zkuste to prosím znovu.', 'error');
            return;
          }
          addMessage(result.data.reply, 'bot');
          history.push({ role: 'assistant', text: result.data.reply });
        })
        .catch(function () {
          addMessage('Podpora je dočasně nedostupná. Napište nám prosím na kontakt.', 'error');
        })
        .finally(function () {
          isSending = false;
          sendBtn.disabled = false;
        });
    }

    widget.querySelectorAll('[data-flowik-chat-question]').forEach(function (btn) {
      btn.addEventListener('click', function () { sendMessage(btn.textContent); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      sendMessage(input.value);
    });

    /* ── Proaktivní "vějička": bublina s náhodnou otázkou, max 1x za session ── */
    var TEASER_SESSION_KEY = 'flowik_chat_teaser_shown';
    var teaser = widget.querySelector('[data-flowik-chat-teaser]');
    var teaserText = widget.querySelector('[data-flowik-chat-teaser-text]');
    var teaserClose = widget.querySelector('[data-flowik-chat-teaser-close]');
    var teaserShowTimer = null;
    var teaserHideTimer = null;

    function markTeaserShown() {
      try { sessionStorage.setItem(TEASER_SESSION_KEY, '1'); } catch (e) {}
    }
    function teaserAlreadyShown() {
      try { return sessionStorage.getItem(TEASER_SESSION_KEY) === '1'; } catch (e) { return false; }
    }
    function hideTeaser() {
      teaser.classList.remove('is-visible');
      if (teaserHideTimer) { clearTimeout(teaserHideTimer); teaserHideTimer = null; }
    }
    function cancelTeaser() {
      if (teaserShowTimer) { clearTimeout(teaserShowTimer); teaserShowTimer = null; }
      hideTeaser();
    }

    if (teaser && teaserText && !teaserAlreadyShown()) {
      var questionBtns = widget.querySelectorAll('[data-flowik-chat-question]');
      var showDelay = 10000 + Math.random() * 5000; /* 10-15 s */

      teaserShowTimer = setTimeout(function () {
        if (isOpen || !questionBtns.length) return;
        var pick = questionBtns[Math.floor(Math.random() * questionBtns.length)];
        teaserText.textContent = pick.textContent;
        teaser.classList.add('is-visible');
        markTeaserShown();

        teaserHideTimer = setTimeout(function () {
          teaser.classList.remove('is-visible');
        }, 7000); /* zůstane pár vteřin, pak se sama schová */

        teaser.addEventListener('click', function onTeaserClick(e) {
          if (e.target === teaserClose) return;
          hideTeaser();
          setOpen(true);
          sendMessage(pick.textContent);
          teaser.removeEventListener('click', onTeaserClick);
        });
      }, showDelay);

      teaserClose.addEventListener('click', function (e) {
        e.stopPropagation();
        hideTeaser();
      });
    }

    /* Pokud si uživatel otevře chat sám dřív, než se vějička stihne objevit,
       už ji tuhle session neukazovat */
    toggleBtn.addEventListener('click', function () {
      cancelTeaser();
      markTeaserShown();
    });
  }

  function init() {
    document.querySelectorAll('[data-flowik-chat]').forEach(initChat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
